const defaultDialog = {
  show: false,
  text: null,
  title: null,
  callback: null
};
const defaultAskDialog = {
  show: false,
  text: null,
  title: "Pytanie",
  yesClick: null,
  yesLabel: "TAK",
  noLabel: "NIE",
  noClick: null
};
export default {
  namespaced: true,
  state: {
    isClosedMenu: false,
    isOpenA11y: false,
    isActiveContast: false,
    overlay: false,
    dialog: {
      ...defaultDialog
    },
    askDialog: {
      ...defaultAskDialog
    },
    proposalListFilters: {
      filters: null,
      options: null
    },
    navigationDrawerVisibility: true,
    onLine: true,
    pages: {}
  },
  mutations: {
    setStateMenu(state, isClosed) {
      state.isClosedMenu = isClosed;
    },
    setStateA11y(state, isOpen) {
      state.isOpenA11y = isOpen;
    },
    switchActiveContrast(state) {
      state.isActiveContast = !state.isActiveContast;
    },
    showOverlay(state) {
      state.overlay = true;
    },
    hideOverlay(state) {
      state.overlay = false;
    },
    showInfoDialog(state, payload) {
      state.dialog.title = "Informacje";
      state.dialog.text = payload;
      state.dialog.callback = () => {
        state.dialog = {
          ...defaultDialog
        };
      };
      state.dialog.show = true;
    },
    showInfoDialogTitle(state, payload) {
      state.dialog.title = "Podsumowanie importu";
      state.dialog.text = payload;
      state.dialog.show = true;
    },
    showInfoDialogCallback(state, payload) {
      state.dialog.title = payload.title || "Informacje";
      state.dialog.text = payload.text;
      state.dialog.callback = () => {
        state.dialog = {
          ...defaultDialog
        };
        if (payload.callback) {
          payload.callback(payload.callbackData);
        }
      };
      state.dialog.show = true;
    },
    showErrorDialog(state, payload) {
      state.dialog.title = "Uwaga";
      state.dialog.text = payload;
      state.dialog.callback = () => {
        state.dialog = {
          ...defaultDialog
        };
      };
      state.dialog.show = true;
    },
    hideDialog(state) {
      state.dialog = {
        ...defaultDialog
      };
    },
    showAskDialog(state, payload) {
      let mergePayload = Object.assign({}, defaultAskDialog, payload);
      state.askDialog = mergePayload;
      state.askDialog.yesClick = () => {
        state.askDialog = {
          ...defaultAskDialog
        };
        payload.yesClick(payload.data || payload.yesClickData);
      };
      state.askDialog.noClick = () => {
        state.askDialog = {
          ...defaultAskDialog
        };
        if (payload.noClick) {
          payload.noClick(payload.data || payload.noClickData);
        }
      };
      state.askDialog.show = true;
    },
    hideAskDialog(state) {
      state.askDialog = {
        ...defaultAskDialog
      };
    },
    setProposalListFilters(state, payload) {
      state.proposalListFilters = payload;
    },
    setNavigationDrawerVisibility(state, visibility) {
      state.navigationDrawerVisibility = visibility;
    },
    setOnLine(state, online) {
      state.onLine = online;
    },
    setPage(state, { code, html }) {
      if (!code || !html) return;
      state.pages[code] = html;
    }
  },
  getters: {
    getOverlay(state) {
      return state.overlay;
    },
    getDialog(state) {
      return state.dialog;
    },
    getAskDialog(state) {
      return state.askDialog;
    },
    getProposalListFilters(state) {
      return state.proposalListFilters;
    },
    getNavigationDrawerVisibility(state) {
      return state.navigationDrawerVisibility;
    },
    getOnLine(state) {
      return state.onLine;
    },
    getPage: (state) => (code) => {
      return state.pages[code] || null;
    }
  }
};
